// Value props section (US-108) — section header with AI assist + the
// sentence-list sub-editor. JSX lifted verbatim from BusinessEditor.

import { useT } from '@barel/i18n';
import { BAiButton, Card } from '@barel/ui';

import { SentenceListEditor } from '../ValuePropEditor';
import type { BusinessDraft } from '../lib/defaults';
import { SectionHeader } from './SectionHeader';
import type { RunAi, SetField } from './types';

export interface ValuePropsSectionProps {
  valueProps: BusinessDraft['valueProps'];
  onChange: SetField;
  runAi: RunAi;
  aiBusyField: string | null;
}

export function ValuePropsSection({
  valueProps,
  onChange,
  runAi,
  aiBusyField,
}: ValuePropsSectionProps) {
  const t = useT('businesses');

  return (
    <Card padding="lg" radius="2xl" data-testid="business-section-valueprops">
      <SectionHeader
        title={t('sections.valueProps')}
        subtitle={t('valueProps.subtitle')}
        action={
          <BAiButton
            onClick={() => void runAi('valueProps')}
            busy={aiBusyField === 'valueProps'}
            label={t('valueProps.ai')}
            busyLabel={t('valueProps.aiBusy')}
            data-testid="business-valueprops-ai"
          />
        }
      />
      <SentenceListEditor
        values={valueProps}
        onChange={(next) => onChange('valueProps', next)}
        placeholder={t('valueProps.placeholder')}
        addLabel={t('valueProps.add')}
        testId="business-valueprops"
      />
    </Card>
  );
}
